(() => {
  if (window.mmWholesaleCategories) {
    window.mmWholesaleCategories.initialize(document);
    return;
  }

  const selector = '[data-mm-wholesale-categories]';
  const categories = new Set(['all', 'ceremonial', 'premium', 'culinary', 'trial']);
  const controllers = new WeakMap();
  const selections = new Map();

  function findRoots(scope) {
    const roots = Array.from(scope.querySelectorAll(selector));
    if (scope.matches?.(selector)) roots.unshift(scope);
    return roots;
  }

  function initialize(scope) {
    findRoots(scope).forEach((root) => {
      if (controllers.has(root)) return;
      const section = root.closest('.shopify-section');
      const container = section?.querySelector('#ProductGridContainer');
      const controls = root.querySelector('[data-mm-category-controls]');
      if (!section || !container || !controls) return;

      const key = root.dataset.sectionId || section.id;
      let selected = selections.get(key) || 'all';

      function countText(count) {
        const template = count === 1 && root.dataset.countOneTemplate
          ? root.dataset.countOneTemplate
          : root.dataset.countTemplate;
        return template
          ? template.replace(/\[count\]|\{\{\s*count\s*\}\}/g, String(count))
          : String(count);
      }

      function setText(element, value) {
        if (element && element.textContent !== value) element.textContent = value;
      }

      function apply() {
        const items = container.querySelectorAll('#product-grid > li[data-mm-product-category]');
        let count = 0;
        items.forEach((item) => {
          const visible = selected === 'all' || item.dataset.mmProductCategory === selected;
          item.hidden = !visible;
          if (visible) count += 1;
        });

        root.querySelectorAll('[data-mm-category-button]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.category === selected));
        });

        const text = countText(count);
        setText(root.querySelector('[data-mm-category-status]'), text);
        section.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach((element) => {
          setText(element, text);
        });

        const empty = root.querySelector('[data-mm-category-empty]');
        if (empty) {
          if (root.dataset.emptyText) setText(empty, root.dataset.emptyText);
          empty.hidden = count !== 0 || selected === 'all';
        }
      }

      function onClick(event) {
        const button = event.target.closest?.('[data-mm-category-button]');
        if (!button || !controls.contains(button)) return;
        const category = button.dataset.category;
        if (!categories.has(category)) return;
        event.preventDefault();
        selected = category;
        selections.set(key, selected);
        apply();
      }

      const observer = new MutationObserver((records) => {
        const grid = container.querySelector('#product-grid');
        const gridChanged = records.some((record) => {
          if (record.target === container || record.target === grid) return true;
          return [...record.addedNodes, ...record.removedNodes].some((node) =>
            node.nodeType === 1 &&
            (node.matches('#product-grid') || node.querySelector('#product-grid'))
          );
        });
        if (gridChanged) apply();
      });

      root.addEventListener('click', onClick);
      observer.observe(container, { childList: true, subtree: true });
      controllers.set(root, {
        destroy() {
          observer.disconnect();
          root.removeEventListener('click', onClick);
          controllers.delete(root);
        },
      });
      apply();
      controls.hidden = false;
    });
  }

  window.mmWholesaleCategories = { initialize };
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    findRoots(event.target).forEach((root) => controllers.get(root)?.destroy());
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
